<template>
  <bk-page
    :navBarInfo="navBarInfo"
    pageType="navPage"
    class="appointmentDetailsPage"
    @close="close"
    :loading="loadView === 'view'"
  >
    <bk-view class="view-box">
      <bk-view class="view-actionRequired-main" v-if="resDetail.isFormstobecompleted">
        <bk-icon icon="icon-tishi"></bk-icon>
        <bk-lang code="appointment_formstobecompleted"></bk-lang>
      </bk-view>
      <bk-view class="view-info-main">
        <bk-view class="detail-wrapper" v-show="!componentName">
          <!--			<bk-view id="container" class="container"></bk-view>-->
          <bk-view class="view-imgLoc-main">
            <bk-image v-if="showMapUrl" class="img-loc" :src="showMapUrl" :style="{ width: '100%' }"></bk-image>
            <bk-view class="shop-view">
              <bk-image :src="resDetail?.maSeCompInfo?.logo || $bk_getImageUrl('Def_Img_Mask.png')"></bk-image>
              <bk-view>
                <bk-view class="name">{{ resDetail.compName }}</bk-view>
                <bk-view class="addr">
                  <bk-icon size="def" icon="icon-dingwei"></bk-icon>
                  <span>{{ resDetail?.maSeCompInfo?.address }}</span>
                </bk-view>
              </bk-view>
              <bk-image
                class="view-iconNav"
                @click="navToDestination"
                :src="$bk_getImageUrl('Def_Icon_Nav.png')"
              ></bk-image>
            </bk-view>
          </bk-view>

          <bk-view class="s-wrapper">
            <!-- 团体预约 -->
            <bk-view
              class="view-groupReserve-main"
              v-if="resDetail.groupReserve === 1 && resDetail.groupReserveProjectList?.length"
            >
              <bk-view
                class="view-customer-row"
                v-for="customerItem in resDetail.groupReserveProjectList"
                :key="customerItem.customerIndex"
              >
                <bk-view class="view-title-main">
                  <bk-lang code="res_add_groupReserve_customer"></bk-lang>
                  <span>{{ customerItem.customerName }}</span>
                </bk-view>
                <bk-view class="view-project-list">
                  <bk-view class="view-projectInfo" v-for="item in customerItem.reserveProjectList" :key="item.id">
                    <bk-view class="s-item">
                      <bk-image :src="item.showCoverImg || $bk_getImageUrl('Def_Img_Service.png')"></bk-image>
                      <bk-view class="s-info">
                        <bk-view class="view-name">{{ item.name }}</bk-view>
                        <span class="view-bottom-main">
                          <template v-if="item.assign==1 && item.itemsEmployeeList?.length">
														<bk-lang code="reserve_with" /> 
														{{ resEmpNameStr(item.itemsEmployeeList) }}
													</template>
                          <bk-lang v-else code="appointment_walk_in"></bk-lang>
                          <span style="padding: 5px"
                            ><bk-date :curShop="item" :date="item.startDateTime.showValue" showHm showWeek></bk-date
                          ></span>
                        </span>
                      </bk-view>
                      <bk-price
                        :unitText="resDetail.currencySymbol"
                        :value="item.staffPrice != null ? item.staffPrice : item.price"
												:priceType="item.staffPriceType || item.priceType"
                      ></bk-price>
                    </bk-view>
                    <addItemsList :dataList="item.addItemsList" :unitText="resDetail.currencySymbol" />
                  </bk-view>
                </bk-view>
              </bk-view>
            </bk-view>
            <bk-view v-else class="view-project-list">
              <bk-view class="view-projectInfo" v-for="item in resDetail.reserveProjectList" :key="item.id">
                <bk-view class="s-item">
                  <bk-image :src="item.showCoverImg || $bk_getImageUrl('Def_Img_Service.png')"></bk-image>
                  <bk-view class="s-info">
                    <bk-view class="view-name">{{ item.name }}</bk-view>
                    <span class="view-bottom-main">
                      <template v-if="item.assign==1 && item.itemsEmployeeList?.length"
                        ><bk-lang code="reserve_with" /> {{ resEmpNameStr(item.itemsEmployeeList) }}</template
                      >
                      <bk-lang v-else code="appointment_walk_in"></bk-lang>
                      <span v-if="bizScene==='reserve'" style="padding: 5px">
												<bk-date :curShop="item" :date="item.startDateTime.showValue" showHm showWeek></bk-date>
											</span>
                    </span>
                  </bk-view>
                  <bk-price
                    :unitText="resDetail.currencySymbol"
                    :value="item.staffPrice != null ? item.staffPrice : item.price"
										:priceType="item.staffPriceType || item.priceType"
                  ></bk-price>
                </bk-view>
                <addItemsList :dataList="item.addItemsList" :unitText="resDetail.currencySymbol" />
              </bk-view>
            </bk-view>

            <div 
							class="view-status-main" 
							v-if="langCode_status"
							:class="{
								[bizScene]: true,
								['view-status-' + resDetail.status]: true,
								['view-avaBookStatus-' + resDetail.avaBookStatus]: true,
							}" 
						>
              <bk-lang :code="langCode_status"></bk-lang>
            </div>
          </bk-view>

          <bk-view
            :class="{
              'res-total': true,
            }"
          >
					<!-- 'view-preAuth-main': isPreAuthPay -->
            <bk-lang class="view-detailTotal" code="a_detail_total"></bk-lang>
            <bk-price class="view-amount" :unitText="resDetail.currencySymbol" :priceType="totalPriceType" :value="resDetail.amount"></bk-price>

            <bk-view class="view-paid-main" v-if="resDetail.reserveCharge && isDepositPay && bizScene==='reserve'">
              <!-- @click="setShowPage('depositPolicy')" -->
              <bk-view class="view-paid-item view-paid-item-1">
                <!-- <bk-view class="view-tipIcon" v-if="!isRefundedSuccess"></bk-view> -->
                <a-tooltip>
                  <template #title>
                    <bk-lang v-if="isStorePaid" code="appointment_detail_storedPaid_tip"></bk-lang>
                  </template>
                  <bk-view v-if="isStorePaid" class="view-tipIcon"></bk-view>
                </a-tooltip>
                <bk-lang v-if="isStorePaid" code="appointment_detail_storedPaid"></bk-lang>
                <bk-lang v-else code="appointment_detail_paid"></bk-lang>
                <bk-price
									v-if="isDepositPay"
                  class="view-depositAmount"
                  :unitText="resDetail.currencySymbol"
                  :value="maSeReserveItem.amount"
                ></bk-price>
              </bk-view>
              <!-- <bk-view v-if="isPreAuthPay && resDetail.status !== 9" class="view-paid-item view-paid-item-2">
                <bk-lang code="appointment_detail_instorePayment"></bk-lang>
                <bk-price
                  class="view-depositAmount"
                  :unitText="resDetail.currencySymbol"
                  :value="resDetail.depositAmount"
                ></bk-price>
              </bk-view> -->
              <bk-view class="view-paid-item view-paid-item-3" v-if="isRefundedSuccess">
                <bk-lang code="appointment_detail_refunded"></bk-lang>
              </bk-view>
            </bk-view>
          </bk-view>

          <bk-view class="view-archives-main" v-if="resDetail.id && bizScene==='reserve'">
            <bkArchivesInfo
              ref="archivesInfo"
              :triggerItemList="triggerItemList"
              :compId="resDetail.compId"
              :relationId="resDetail.id"
              :memberId="resDetail.memberId"
              :profileList="resDetail.reserveRelated?.profile || []"
              :manualList="resDetail.reserveRelated?.manualProfileList || []"
              :filterIds="resDetail.reserveRelated?.delProfileIds || []"
              @action="handleArchivesAction"
            />
          </bk-view>

          <bk-view class="view-note-main" v-if="resDetail.remark || resDetail.reserveRelated?.remarkImage?.length">
            <bk-lang class="view-title" code="appointment_detail_note" />
            <bk-view class="view-info">
              <bk-view class="view-remark" v-if="resDetail.remark">{{ resDetail.remark }}</bk-view>
              <bk-view class="view-image-list">
                <bk-image
                  v-for="item in resDetail?.reserveRelated?.remarkImages || []"
                  preview
                  :src="item"
                  :key="item"
                  :sources="resDetail?.reserveRelated?.remarkImages"
                />
              </bk-view>
            </bk-view>
          </bk-view>

          <bk-view v-if="resDetail.status == 2" class="view-refuseReason-main">
            <bk-title langCode="appointment_reason"></bk-title>
            <bk-view class="view-value">{{ resDetail.refuseReason || '-' }}</bk-view>
          </bk-view>
        </bk-view>

        <template v-if="resDetail.status !== 2">

					<bk-masePowered style="padding: 0 0 28px;" />
					
					<bk-view class="btn-views" v-if="bizScene==='waiting'">
						<bk-button langCode="appointment_leaveWaitlis"  @click="handleItemAction('leaveWaitlist')"></bk-button>
						<bk-button v-if="resDetail.avaBookStatus == 1" @click="handleItemAction('bookAgain')" langCode="reserve_waitlist_bookNow"></bk-button>
					</bk-view>
					
					<template v-else>
						<bk-view :class="['btn-views', this.isReviews ? 'book-views' : '']" v-if="status == 1">
							<bk-button v-if="!this.isReviews" @click="goOrderReviews()" langCode="a_button_leave_review"></bk-button>
							<bk-button @click="setCurName('reserve')" langCode="a_button_book_again"></bk-button>
						</bk-view>

						<bk-view class="btn-views cancel-views" v-else-if="status == 0">
							<bk-button @click="handleCancel" langCode="a_button_book_cancel"></bk-button>
							<bk-button @click="handleReschedule" langCode="a_button_book_reschedule"></bk-button>
						</bk-view>

						<bk-view class="btn-views book-views" v-else>
							<bk-button @click="setCurName('reserve')" langCode="a_button_book_again"></bk-button>
						</bk-view>
					</template>
        </template>
      </bk-view>
    </bk-view>
    <transition name="rightFadeIn">
      <component
        v-if="componentName"
        :is="componentName"
        mode="component"
        :resInfo="resDetail"
        :resShopInfo="resDetail?.maSeCompInfo || {}"
        @close="setCurName(null)"
      >
      </component>
    </transition>

    <depositPolicy :show="showPage === 'depositPolicy'" :resDetail="resDetail" @close="setShowPage()" />

		<breachPenaltyConfirm 
			:show="showPage==='breachPenaltyConfirm'"
			:reserveInfo="resDetail"
			:curRows="{ status: 3 }"
			@close="setShowPage()"	
			@confirm="handleBreachPenaltyConfirm"
		/>

  </bk-page>
</template>

<script>
	import dayjs from 'dayjs';
	import AMapLoader from '@vuemap/amap-jsapi-loader';
	import depositPolicy from './depositPolicy/depositPolicy.vue';
	import addItemsList from './addItemsList/addItemsList.vue';
	import Reserve from '@/pages/reserve/reserve';
	import bkArchivesInfo from '@/components/bk-business/bk-archivesInfo/bk-archivesInfo.vue';
	import breachPenaltyConfirm from './breachPenaltyConfirm/breachPenaltyConfirm.vue';
	import AMap from '../aMap/aMap';
	import { reserveReq, shopReq, customerReq } from '@/reqService';

	const dateMap = {
		en: 'DD-MM-YYYY HH:mm',
	};

	// ...

	export default {
		name: 'AppointmentDetail',
		components: { Reserve, AMap, depositPolicy, bkArchivesInfo, addItemsList, breachPenaltyConfirm },
		emits: ['close'],
		props: {
			id: String,
			status: String,
			bizScene:String,
		},
		data () {
			return {
				resDetail: {},
				marker: [],
				componentName: null,
				loadView: '',
				languageType: this.$bk_getLanguageType(),
				showPage: '',
				archivesList: [],
				// 订单是否已经评价
				isReviews: false,
			};
		},

		computed: {
			navBarInfo(){
				return {
					backFlag: true,
					langCode_title: this.bizScene==='waiting' ? 'appointment_waitlistDetails' : 'appointment_detail_title'
				}
			},
			// 合计价格类型
			totalPriceType (){
				const { reserveProjectList} = this.resDetail;
				return this.$bk_resvIsContainFromPrice(reserveProjectList) ? 'FROM' : undefined;
			},
			triggerItemList () {
				const { reserveProjectList = [] } = this.resDetail;
				return reserveProjectList.map((item) => {
					return { goodsCode: item.code, goodsType: 2 };
				});
			},
			showMapUrl () {
				let center;

				let { resDetail } = this;

				if (!resDetail || !resDetail.maSeCompInfo || !resDetail.maSeCompInfo.lat) {
					return;
				}

				center = [resDetail.maSeCompInfo.lat, resDetail.maSeCompInfo.lng];

				if (!center) {
					return undefined;
				}

				return `https://maps.googleapis.com/maps/api/staticmap?center=${center[0]},${center[1]}&zoom=17&size=400x188&key=AIzaSyAPo7EYpiT1rDd8mg9Vqdrze05-jiLkxbM&scale=2&markers=size:mid|color:red|label:A|${center[0]},${center[1]}`;
			},
			// 状态
			langCode_status () {
				let { resDetail } = this;

				if(this.bizScene==='waiting'){
					return {
						0:'appointment_waiting',
						1:'appointment_slotAvailable'
					}[resDetail.avaBookStatus]
				}

				let obj = {
					1: 'appointment_upcoming',

					5: 'appointment_finished',
					6: 'appointment_finished',
					7: 'appointment_finished',

					3: 'appointment_cancelled',
					8: 'appointment_cancelled',

					0: 'appointment_tobeConfirmed',
					2: 'appointment_rejected',
				};

				return obj[resDetail.status];
			},
			curResDate () {
				const { displayValue } = this.resDetail?.startDateTime;
				return dayjs(displayValue || '').format('YYYY/MM/DD HH:mm');
			},
			resEmpNameStr () {
				return (list) => {
					return list
						.map((item) => {
							return item.name;
						})
						?.join(',');
				};
			},
			maSeReserveItem () {
				const { reserveCharge } = this.resDetail;
				const { reservePaymentList=[] } = reserveCharge || {};
				return reservePaymentList[0] || {};
			},
			isRefundedSuccess () {
				return this.maSeReserveItem?.paymentStatus === 'RS';
			},	
			// 收费形式 定金
			isDepositPay (){
				const { reserveCharge } = this.resDetail;
				return String(reserveCharge?.chargeForm) ==='0';
			},
			// 收费形式 预授权
			isPreAuthPay () {
				const { reserveCharge } = this.resDetail;
				return String(reserveCharge?.chargeForm) ==='1';
			},
			// 储值支付
			isStorePaid () {
				return this.maSeReserveItem.paymentMethod === 'STORE';
			},
		},
		methods: {
			// 跳评论页
			goOrderReviews () {
				const { billId } = this.resDetail;
				this.$router.push({
					name: 'OrderReviews',
					params: { billId: billId },
				});
			},
			close () {
				this.$emit('close');
			},
			setShowPage (showPage = '') {
				this.showPage = showPage;
			},
			formatTime (date) {
				const _format = dateMap[this.languageType] || 'YYYY-MM-DD HH:mm';
				return dayjs(date).format(_format);
			},
			// 获取是否已经评价
			async getMemberReviewsByBillId () {
				const { billId } = this.resDetail;
				if(!billId){
					return false;
				}
				const res = await customerReq.requestGetMemberReviewsByBillId(this, billId);
				this.isReviews = !(
					res == null ||
					res === true ||
					res === false ||
					(Array.isArray(res) && res.length === 0) ||
					(typeof res === 'object' && Object.keys(res).length === 0) ||
					res === ''
				);
			},
			// 获取预约详情
			async getReserveDetailById () {
				this.loadView = 'view';

				let res;
				if(this.bizScene==='waiting'){
					res = await reserveReq.requestWaitlistDetail(this, {id: this.id }).catch(() => {});
				}else{
					res = await reserveReq.requestGetResDetailById(this, this.id).catch(() => {});
				}

				if (res?.id) {
					const resShop = await shopReq.requestGetShopDetailByCompId(this, res.compId);

					res.currencySymbol = resShop.currencySymbol;

					this.resDetail = res;
				}
				this.loadView = '';
			},
			async isBreachPenaltyConfirm (status){
				let x = this.isPreAuthPay && this.$bk_resvDepositPaySuccess(this.resDetail);

				if(x && this.$bk_notNull(status)){
					let resPenalty = await reserveReq.requestPenaltyInfo(this, { ...this.resDetail, status });
					// 触发了扣款规则
					if(resPenalty?.isPenalty==1){
						this.cacheItem = { status };
						this.setShowPage('breachPenaltyConfirm');
						return true;
					}
				}

				if([3].includes(status) && this.$bk_resvStartPayment(this.formData)){
					this.updateReserveStatus({ status, reserveCharge: { payChargeAction: 0 }});
					return true;
				}

				return false;
			},
			async handleCancel () {
				this.$bk_confirm({
					message: this.$bk_getTextWithLangCode('a_cancel_tips'),
				})
					.then(async () => {
						if(await this.isBreachPenaltyConfirm(3)){
							return false;
						}

						await this.updateReserveStatus({ status: 3 });
						this.$bk_message.success({
							langCode: 'a_cancel_success_tips',
						});

						this.$emit('close');
						this.$emit('reload');
					})
			},
			async handleReschedule () {

				this.$bk_confirm({
					langCode_message: 'a_reschedule_tips',
					langCode_cancelButton: 'a_cancel_button_text',
					langCode_confirmButton: 'a_confirm_button_reschedule',
				}).then(async () => {

					if(await this.isBreachPenaltyConfirm(3)){
						return false;
					}
				
					await this.updateReserveStatus({ status: 3 });
					this.$bk_message.success({
						langCode: 'a_cancel_success_tips',
					});
					this.setCurName('reserve');
				}).catch((err) => {});
			},
			async handleBreachPenaltyConfirm (){
				this.setShowPage();
				let editStatus = { status:3, reserveCharge:{ payChargeAction: 1 } };
				this.updateReserveStatus(editStatus);
				this.$emit('close');
				this.$emit('reload');
			},	
			async updateReserveStatus (data={}){
				const { id } = this.resDetail;
				await reserveReq.requsetPostChangeCalendarStatus(this, { id, ...data });
			},
			async initMap () {
				return;

				// this.handleSearch();
				// AMapLoader.load({
				// 	key: 'ee98e576563dcc72e6d992ac51c0bc25', // mase-customer
				// 	// version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
				// 	plugins: ['AMap.PlaceSearch', 'AMap.AutoComplete']
				// }).then((AMap) => {

				// }).catch((e) => {
				// 	console.log(e);
				// });
			},

			handleSearch () {
				const address = this.resDetail?.maSeCompInfo?.address;
				const placeSearch = new window.AMap.PlaceSearch(); //构造地点查询类
				placeSearch.search(address, (status, result) => {
					// 查询成功时，result即对应匹配的POI信息
					const pois = result.poiList.pois;
					this.map.remove(this.marker);
					if (this.infoWindow) {
						this.map.remove(this.infoWindow);
					}
					if (pois.length === 0) {
						this.$message({
							message: '没有查询到相关地点，请手动点击地图相应位置获取经纬度',
							type: 'warning',
						});
						return false;
					}
					// this.map.off('click', this.mapClick);
					let poi = pois[0];
					this.marker[0] = new window.AMap.Marker({
						position: poi.location, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
					});
					// 将创建的点标记添加到已有的地图实例：
					this.map.add(this.marker[0]);
					this.map.setFitView();
				});
			},

			// 跳转高德地图导航的H5页面
			navToDestination () {
				this.setCurName('AMap');
				// const { lat, lng, address } = this.resDetail?.maSeCompInfo
				// window.location.href = `http://uri.amap.com/marker?position=${lng},${lat}&name=${address}`
			},

			setCurName (name) {
				this.componentName = name;
			},
			handleArchivesAction ({ key, list }) {
				if (key === 'loadArchives') {
					const profile = this.resDetail?.reserveRelated?.profile || [];
					this.resDetail.isFormstobecompleted = list.length && list.length !== profile?.length;
					return false;
				}

				if (key === 'editArchives') {
					const manualProfileList = this.resDetail?.reserveRelated?.manualProfileList || [];
					let params = { id: this.resDetail.id, reserveRelated: {} };

					params.reserveRelated.profile = list.map((item) => {
						return {
							templateId: item.templateId,
							profileId: item.profileId,
						};
					});

					if (manualProfileList?.length) {
						params.reserveRelated.manualProfileList = manualProfileList.filter((item) => {
							return !this.$bk_findItem(list, item.id, 'templateId').templateId;
						});
					}

					reserveReq.requestPostEditReserveProfile(this, params).then(() => {
						this.$bk_message.success({ langCode: 'global_msg_saveSuccessfully' });
						this.getReserveDetailById();
					});
					return false;
				}
			},
			handleItemAction(key){
				const { id, compId, custId } = this.resDetail;

				if (key === 'leaveWaitlist') {
					this.$bk_confirm({
						langCode_title: 'appointment_leaveWaitlis',
						langCode_message: 'appointment_msg_leavethewaitlist',
						langCode_confirmButton:'appointment_leave',
					}).then(async () => {
						await reserveReq.requestEditWaitlistStatus(this, { id, status: 3 })
						this.$bk_message.success({langCode:'global_message_success_action'})
						this.$emit('close');
						this.$emit('reload');
					})
				return;
				} 

				if (key === 'bookAgain') {
					this.$router.push({
						path:"/reserveWaitingAction",
						query:{ waitlistId:id , action: 'BOOKING'}
					})
					return;
				}
			}
		},
		async mounted () {
			await this.getReserveDetailById();

			if(this.bizScene==='reserve'){
				// 判断评价状态
				await this.getMemberReviewsByBillId();
			}
			
			this.initMap();
		},
		beforeUnmount () {
			this.$store.commit('setItemState', { expandArchiveInfo: {} });
		},
	};
</script>

<style lang="less">
  @import './appointmentDetail.less';
</style>
